/**
 * 公共卫生模块路由配置
 *
 * @module public-health/routes
 */

import { RouteRecordRaw } from "vue-router";

/**
 * 公共卫生模块路由
 */
export const publicHealthRoutes: RouteRecordRaw[] = [
  {
    path: "/public-health",
    name: "PublicHealth",
    component: () => import("@/views/management/ManagementLayout.vue"),
    redirect: "/public-health/elderly",
    meta: {
      title: "公共卫生服务",
      requiresAuth: true,
      keepAlive: true,
      breadcrumb: ["首页", "公共卫生服务"],
    },
    children: [
      {
        path: "elderly",
        name: "ElderlyHealth",
        component: () =>
          import("./elderly/interfaces/ElderlyHealthWorkflow.vue"),
        meta: { title: "老年人健康管理" },
      },
      {
        path: "hypertension",
        name: "HypertensionManagement",
        component: () =>
          import("./hypertension/interfaces/HypertensionFollowupWorkflow.vue"),
        meta: { title: "高血压管理" },
      },
      {
        path: "diabetes",
        name: "DiabetesManagement",
        component: () =>
          import("./diabetes/interfaces/DiabetesFollowupWorkflow.vue"),
        meta: { title: "糖尿病管理" },
      },
      {
        path: "mental-health",
        name: "MentalHealthManagement",
        component: () =>
          import("./mental-health/interfaces/MentalHealthWorkflow.vue"),
        meta: { title: "精神卫生" },
      },
    ],
  },
];

export default publicHealthRoutes;
